(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["metaobject-media-gallery-block"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('metaobject-media-gallery')) {
    class MetaobjectMediaGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.track = this.querySelector('[data-slides]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.thumbnails = [...this.querySelectorAll('[data-thumbnail]')];
        this.dots = [...this.querySelectorAll('[data-dot]')];
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.counter = this.querySelector('[data-current]');
        this.mobileCounter = this.querySelector('[data-current-mobile]');
        this.dialog = document.getElementById(`MetaGalleryDialog-${this.dataset.galleryId}`);
        this.currentIndex = 0;
        this.scrollTimer = null;

        this.prev?.addEventListener('click', () => this.goTo(this.currentIndex - 1));
        this.next?.addEventListener('click', () => this.goTo(this.currentIndex + 1));

        this.thumbnails.forEach((button) => {
          button.addEventListener('click', () => this.goTo(Number(button.dataset.thumbnail)));
        });

        this.dots.forEach((button) => {
          button.addEventListener('click', () => this.goTo(Number(button.dataset.dot)));
        });

        this.track?.addEventListener('scroll', () => {
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.syncFromScroll(), 50);
        }, { passive: true });

        // Do not manually move the carousel during touch dragging.
        // The browser's native horizontal scrolling + scroll-snap handles it.
        // We only track whether a drag happened so a drag does not accidentally
        // trigger the image zoom click afterwards.
        let touchStartX = 0;
        let touchStartY = 0;
        let touchDragged = false;

        this.track?.addEventListener('touchstart', (event) => {
          if (event.touches.length !== 1) return;
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
          touchDragged = false;
        }, { passive: true });

        this.track?.addEventListener('touchmove', (event) => {
          if (event.touches.length !== 1) return;
          const dx = Math.abs(event.touches[0].clientX - touchStartX);
          const dy = Math.abs(event.touches[0].clientY - touchStartY);

          if (dx > 10 && dx > dy) {
            touchDragged = true;
          }
        }, { passive: true });

        this.track?.addEventListener('touchend', () => {
          if (!touchDragged) return;
          this.suppressZoomClick = true;
          window.setTimeout(() => {
            this.suppressZoomClick = false;
          }, 100);
        }, { passive: true });

        this.track?.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            this.goTo(this.currentIndex - 1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            this.goTo(this.currentIndex + 1);
          }
        });

        this.querySelectorAll('[data-zoom-index]').forEach((button) => {
          button.addEventListener('click', () => this.openZoom(Number(button.dataset.zoomIndex)));
        });

        // On mobile the transparent zoom button is pointer-events:none so it
        // cannot interfere with horizontal dragging. The media wrapper handles
        // the tap-to-zoom behavior instead.
        this.querySelectorAll('.hzg-meta-gallery__media[data-zoom-index]').forEach((media) => {
          media.addEventListener('click', (event) => {
            if (this.suppressZoomClick) {
              event.preventDefault();
              event.stopPropagation();
              this.suppressZoomClick = false;
              return;
            }

            if (window.matchMedia('(max-width: 749px)').matches) {
              this.openZoom(Number(media.dataset.zoomIndex));
            }
          });
        });

        this.querySelectorAll('[data-grid-item]').forEach((item) => {
          item.addEventListener('click', (event) => {
            if (event.target.closest('button, a')) return;
            this.openZoom(Number(item.dataset.index));
          });
        });

        this.dialog?.querySelector('[data-close]')?.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.dialog?.close();
        });
        // Zoom dialog: clicking anywhere closes it, including the image,
        // dialog content, or backdrop.
        this.dialog?.addEventListener('click', (event) => {
          if (!this.dialog?.open) return;

          // Do not let the click that opened the dialog affect the dialog;
          // this handler only runs for a pointer interaction after it is open.
          event.preventDefault();
          event.stopPropagation();
          this.dialog.close();
        }, true);

        this.dialog?.addEventListener('click', (event) => {
          if (!this.dialog?.open) return;

          event.preventDefault();
          event.stopPropagation();
          this.dialog.close();
        }, true);

        this.updateUI(0, false);
      }

      goTo(index, smooth = true) {
        if (!this.track || !this.slides.length) return;

        this.currentIndex = (index + this.slides.length) % this.slides.length;
        const slide = this.slides[this.currentIndex];

        // Do not use scrollIntoView(): it can scroll the page or another
        // ancestor. Scrolling the gallery track directly gives a reliable
        // image-to-image transition.
        this.track.scrollTo({
          left: slide.offsetLeft,
          top: 0,
          behavior: smooth ? 'smooth' : 'auto'
        });

        this.updateUI(this.currentIndex, smooth);
      }

      syncFromScroll() {
        if (!this.track || !this.slides.length) return;

        const center = this.track.scrollLeft + this.track.clientWidth / 2;
        let closest = 0;
        let distance = Infinity;

        this.slides.forEach((slide, index) => {
          const slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
          const currentDistance = Math.abs(slideCenter - center);
          if (currentDistance < distance) {
            distance = currentDistance;
            closest = index;
          }
        });

        if (closest !== this.currentIndex) {
          this.currentIndex = closest;
          this.updateUI(closest, true);
        }
      }

      updateUI(index, scrollThumbnail) {
        this.slides.forEach((slide, i) => {
          slide.setAttribute('aria-hidden', i === index ? 'false' : 'true');
        });

        this.thumbnails.forEach((button) => {
          const selected = Number(button.dataset.thumbnail) === index;
          button.setAttribute('aria-selected', selected ? 'true' : 'false');

          if (selected && scrollThumbnail) {
            const track = button.closest('.hzg-meta-gallery__thumbnail-track');

            if (track) {
              const parent = track.closest(
                '.hzg-meta-gallery__thumbnails--left, .hzg-meta-gallery__thumbnails--right'
              );

              const isVertical = !!parent;

              if (isVertical) {
                const trackRect = track.getBoundingClientRect();
                const buttonRect = button.getBoundingClientRect();

                const targetTop =
                  track.scrollTop +
                  (buttonRect.top - trackRect.top) -
                  (track.clientHeight - buttonRect.height) / 2;

                track.scrollTo({
                  top: Math.max(0, Math.min(
                    targetTop,
                    track.scrollHeight - track.clientHeight
                  )),
                  left: 0,
                  behavior: 'smooth'
                });
              } else {
                const trackRect = track.getBoundingClientRect();
                const buttonRect = button.getBoundingClientRect();

                const targetLeft =
                  track.scrollLeft +
                  (buttonRect.left - trackRect.left) -
                  (track.clientWidth - buttonRect.width) / 2;

                track.scrollTo({
                  left: Math.max(0, Math.min(
                    targetLeft,
                    track.scrollWidth - track.clientWidth
                  )),
                  top: 0,
                  behavior: 'smooth'
                });
              }
            }
          }
        });

        this.dots.forEach((button) => {
          button.setAttribute('aria-selected', Number(button.dataset.dot) === index ? 'true' : 'false');
        });

        if (this.counter) this.counter.textContent = index + 1;
        if (this.mobileCounter) this.mobileCounter.textContent = index + 1;
      }

      openZoom(index) {
        if (!this.dialog) return;
        const track = this.dialog.querySelector('[data-dialog-track]');
        const target = track?.querySelector(`[data-dialog-media="${index}"]`);
        this.dialog.showModal();
        requestAnimationFrame(() => target?.scrollIntoView({ behavior: 'instant', block: 'start', inline: 'start' }));
      }
    }

    customElements.define('metaobject-media-gallery', MetaobjectMediaGallery);
  }
  } catch(e) { console.error(e); }
})();

})();
